export const camelCaseToDash = (str: string) =>
  str ? str?.replace(/([a-z])([A-Z])/g, '$1-$2') : '';
